import styled from 'styled-components';
import {StyledAbout,StyledDescription,StyledImage,StyledHide} from '../styles.js';
import Toggle from './Toggle';
import {AnimateSharedLayout} from 'framer-motion';
import {UseScroll} from './UseScroll.js';
import {fadeAnimation} from '../Animation.js';

const FaqSection = () => {
    const [element,controls] = UseScroll();
    return (
        <StyledFaq>
            <h2><span>Experience</span> </h2>

            <AnimateSharedLayout>
            
            <Toggle title ="Mayan - Data Scientist " duration = "July 2021 - Present" >

                <div className="answer">
                    {/* <p></p> */}
                    <ul>
                            <li> Currently working as a Data Scientist at a Y-Combinator backed startup which empowers Amazon sellers to grow their business exponentially using data driven strategies. </li>  
                            <li> Served a multivariate demand forecasting model into production for around 10,000 products using statistical and deep learning-based time series models which has helped prevent stock outs of products by <b>70%.</b></li>
                            <li> Built a full-stack internal data product for account managers in the team to enable at scale Product & Keyword Ad Targeting on Amazon for our products using NLP. This has helped boost Return on Ad Spend (ROAS) by <b> 30% </b> and reduced time on manual ad campaign setup by <b>95%.</b></li>
                    </ul>
                </div>

            </Toggle>    


            <Toggle title ="Student Entrepreneur - xGOLD " duration = "September 2020 - May 2021" >

                <div className="answer">
                    {/* <p></p> */}
                    <ul>
                            <li> Accepted as a student entrepreneur at the incubator program of the University called The Shoebox for a sports analytics company that I founded called xGOLD. </li>  
                            <li> The incubator selects only 30 students out of hundreds of applicants every year to help build their ideas by providing mentorship and resources.</li>
                            <li> The business is about making the recruitment process in football easy by using computer vision & activity recognition to code player actions on the field automatically & use this data to power a personally designed Recommendation engine for player recruitment.</li>
                    </ul>
                </div>

            </Toggle>    

            
            <Toggle title ="Data Science Intern - Total Football Analysis Solutions " duration = "July 2020 - December 2020" >

                <div className="answer">
                    {/* <p></p> */}
                    <ul>
                            
                            <li> Proposed and developed an AI-based, player scouting data product for the company which was sold in a subscription based model to professional football clubs in Spain. </li>  
                            <li> This included writing the data ingestion pipeline, building the Recommendation System Algorithm, tailored to the problem, in Python. Then, developing the frontend of the product in <b>ReactJS</b> and finally connecting it to the backend using <b>FastApi</b>. </li>
                            <li> The product saved club scouts months of manual talent hunting and is being used by them to identify football players around the globe in a data driven, unbiased way.</li>
                            <li> The players recommended by our product based on their statistics have been actually recruited by these professional football clubs in Spain.</li>
                    </ul>
                </div>

            </Toggle>
            
            <Toggle title ="Product Analyst, Growth – Breathe Well-Being " duration = "March 2018-June 2019" >

                <div className="answer">
                    {/* <p></p> */}
                    <ul>
                            
                            <li> Led the product analytics team of a Y-Combinator backed startup which is a digital diabetes management platform.</li>  
                            <li> Managed the Weekly Product Dashboard in the company which included quantitative analysis, data mining using SQL, A/B testing and visualizations using R to see beyond the numbers and understand how users interacted with our product. </li>
                            <li> Improved engagement metrics such as Weekly active users (by 100%), stickiness and net promoter score (by 60%).</li>
                            <li> Implemented a Random Forest model to find key factors that led to drop in HBA1C levels of patients.</li>
                    </ul>
                </div>

            </Toggle>

            <Toggle title =" Research Intern – Boston Consulting Group" duration = "July 2017-February 2018" >

                <div className="answer">
                    {/* <p></p> */}
                    <ul>
                            
                            <li> Developed proven research capabilities for FMCG, manufacturing and financial industries from professional databases like Gartner, Forrester, IDC, Statista, eMarketer, Thomsonone. </li>  
                            <li> Created a digital research repository using HTML and JavaScript, which was used by consultants worldwide. </li>
                    </ul>
                </div>

            </Toggle>

            </AnimateSharedLayout>

        </StyledFaq>
    )

}

const StyledFaq = styled(StyledAbout)`
display:block;
span{
    display:block;
}
h2{
    padding-bottom:2rem; 
    font-weight:lighter;
}
.faq-line{
    background:white;
    height:0.2rem;
    width:100%auto;
    margin: 2rem 0rem;
}

.question{
    padding: 3rem 0rem;
    cursor: pointer;
}
.answer{
    padding:2rem 0rem;
    p{
        padding:1rem 0rem;
    }

}



`

export default FaqSection;